import {createCoreSagas} from '../../../redux/factories/crud/createSagas';
import {actions, actionTypes} from './reducers';
import {call, put} from 'redux-saga/effects';
import {apiClient} from '../../../shared/api';
import {notifyError} from '../../../shared/notificationUtils';
import {downloadPDF} from '../../../shared/pdfUtils';


function* loadDashboard() {
    const response = yield call(apiClient.get, 'report-service/api/v2/report/dashboard', '')

    if (response.error) {
        yield put(actions['loadDashboardFailed'](response.detail));
        yield call(notifyError, response.detail);
    } else {
        yield put(actions['loadDashboardSuccess'](response));
    }
}

function* downloadUserManual() {
    const response = yield call(apiClient.get, 'api/v2/production-support/user-manual', '')

    if (response.error) {
        yield put(actions['downloadUserManualFailed'](response.detail));
        yield call(notifyError, response.detail);
    } else {
        yield put(actions['downloadUserManualSuccess'](response));
        let fileName = response.data.file_name
        let fileURL = response.data.file_url
        downloadPDF(fileName, fileURL)
    }
}

const dashboardSaga = createCoreSagas([
    {
        type: actionTypes['loadDashboard'],
        callback: loadDashboard,
    },
    {
        type: actionTypes['downloadUserManual'],
        callback: downloadUserManual,
    },
]);

export default dashboardSaga;
